import React, { Dispatch, SetStateAction } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { AppDispatch, RootState } from "../../../../../template/store";
import { AESDecrypt } from "../../../../../../../encrypt-util";
import { useParams } from "react-router-dom";
import useDataCountry from "../../../../../../../hooks/useDataCountry";
import { useSelector } from "react-redux";
import useBlCountry from "../../../../../../../hooks/useBlCountry";
import { updateDashbaordRefresh } from "../../../../../../common/components/DataTable/slices/DataTable";
import { getInstructionList } from "../../../../../dashboard/actions/instruction";

interface DoGeneratedDialogModalProp {
    showDoGeneratedDialog:boolean;
    onHide:()=>void;
    setShowDoGeneratedDialog:(flag:boolean)=>void;
    isProcessing:string
    matchPth:boolean
    handleBack: () => void
    setDoGeneratedAMS: Dispatch<SetStateAction<"Y" | "N">>
    updateIsProcessing: (payload: any) => Promise<void>
    demurrageForm: any
    blCountry: string;

}

const DoGeneratedDialogModal=({showDoGeneratedDialog,setShowDoGeneratedDialog,onHide,isProcessing,matchPth,handleBack,setDoGeneratedAMS,updateIsProcessing,demurrageForm,blCountry}:DoGeneratedDialogModalProp)=>{
    // const [blCountry, setBlCountry] = useBlCountry(
    //     matchPth ? "view" : "new",
    //     "import",
    //     820
    //   );
  const dataCountry = useDataCountry();
  const { blNum, encrypt, encryptdoc, blId } = useParams();
    const dispatch=useDispatch<AppDispatch>();
  const decrptdoc = AESDecrypt(encryptdoc);
  const profileDetails = useSelector((state: RootState) => state.userProfile.profile);



    return (<Modal
        show={showDoGeneratedDialog}
        onHide={onHide}
        centered
        size='lg'
      >
        <Modal.Header className='p-2 pb-1' closeButton>
          <Modal.Title>
            DO generated on AMS
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <div>
            Are you sure you want to change the request status to Processing? Once updated, further edits will not be allowed. Click 'OK' to contine
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button variant="secondary" onClick={() => {
            setShowDoGeneratedDialog(false);
            setDoGeneratedAMS('N')
          }}>
            Cancel
          </Button>
          <Button variant="primary" onClick={() => {
            if (isProcessing === '') {
              updateIsProcessing({ demmurrageId: decrptdoc, blId: AESDecrypt(blNum) ?? demurrageForm?.blId })
              setShowDoGeneratedDialog(false)
              setDoGeneratedAMS('Y')
              setTimeout(() => {
                dispatch(
                  getInstructionList({
                    blNum: AESDecrypt(blNum),
                    country: profileDetails.partnerType == "liner" ? dataCountry : blCountry
                  })
                );
                dispatch(updateDashbaordRefresh(true))
              }, 3500);
              handleBack()
            }
          }}>
            Ok
          </Button>
        </Modal.Footer>
      </Modal>)
}

export default DoGeneratedDialogModal;